// Type definitions and default state for the RB Restoration Service Agreement.

export type ContractScope = "insurance_approval" | "price_subject_to_scope" | "retail_finance";

export interface RBAgreementData {
  // Header / homeowner
  homeowner: string;
  phone: string;
  address: string;
  city: string;
  state_zip: string;
  email: string;
  type_of_loss: string;
  claim_number: string;

  // Contract subject to (multi-select)
  scope_insurance_approval: boolean;
  scope_price_subject: boolean;
  scope_retail_finance: boolean;

  total_price: string;
  deposit: string;
  monthly_count: string;
  monthly_amount: string;

  // Specified services - flags
  svc_reconstruction: boolean;
  recon_roof_sq: string;
  recon_shed_sq: string;
  recon_brand: string;
  recon_color: string;
  recon_brand2: string;
  recon_color2: string;
  recon_gutters_lf: string;
  recon_downsp_lf: string;
  recon_layers: string;
  recon_osb: string;
  recon_stories: string;

  svc_gutters: boolean;
  gutters_measurements: string;
  gutters_brand: string;
  gutters_color: string;
  gutters_lf: string;
  gutters_downsp_lf: string;

  svc_water_dryout: boolean;

  svc_interior: boolean;
  interior_notes: string;

  svc_windows: boolean;
  windows_count: string;
  windows_color: string;
  windows_grids: string;
  windows_brand: string;
  windows_doors: string;
  windows_sliding: string;
  windows_french: string;

  svc_emergency_mitigation: boolean;

  svc_siding: boolean;
  siding_measurements: string;
  siding_color: string;
  siding_brand: string;
  siding_style_d4: boolean;
  siding_style_dutch: boolean;
  siding_fanfold: string;
  siding_house_wrap: string;

  // Acknowledgements
  finance_initial: string;

  // Signatures (data URLs)
  homeowner_signature: string;
  homeowner_sign_date: string;
  rep_signature: string;
  rep_sign_date: string;

  // Cancellation
  contract_date: string;
  cancel_customer_name: string;
  cancel_phone: string;
  cancel_address: string;
  cancel_signed_date: string;
  cancel_signature: string;

  // Color selection
  color_choice: string;
  color_other: string;
  color_initial: string;

  // Certificate of completion
  cert_claim_number: string;
  cert_address: string;
  cert_city: string;
  cert_state: string;
  cert_zip: string;
  cert_damage_type: string;
  cert_loss_date: string;
  cert_homeowner_signature: string;
}

export const SHINGLE_COLORS = [
  "Barkwood",
  "Charcoal",
  "Fox Hollow Gray",
  "Hickory",
  "Hunter Green",
  "Mission Brown",
  "Oyster Gray",
  "Pewter Gray",
  "Shakewood",
  "Slate",
  "Weathered Wood",
  "Williamsburg Slate",
];

export const emptyAgreement = (): RBAgreementData => ({
  homeowner: "",
  phone: "",
  address: "",
  city: "",
  state_zip: "",
  email: "",
  type_of_loss: "",
  claim_number: "",
  scope_insurance_approval: false,
  scope_price_subject: false,
  scope_retail_finance: false,
  total_price: "",
  deposit: "",
  monthly_count: "",
  monthly_amount: "",
  svc_reconstruction: false,
  recon_roof_sq: "",
  recon_shed_sq: "",
  recon_brand: "",
  recon_color: "",
  recon_brand2: "",
  recon_color2: "",
  recon_gutters_lf: "",
  recon_downsp_lf: "",
  recon_layers: "",
  recon_osb: "",
  recon_stories: "",
  svc_gutters: false,
  gutters_measurements: "",
  gutters_brand: "",
  gutters_color: "",
  gutters_lf: "",
  gutters_downsp_lf: "",
  svc_water_dryout: false,
  svc_interior: false,
  interior_notes: "",
  svc_windows: false,
  windows_count: "",
  windows_color: "",
  windows_grids: "",
  windows_brand: "",
  windows_doors: "",
  windows_sliding: "",
  windows_french: "",
  svc_emergency_mitigation: false,
  svc_siding: false,
  siding_measurements: "",
  siding_color: "",
  siding_brand: "",
  siding_style_d4: false,
  siding_style_dutch: false,
  siding_fanfold: "",
  siding_house_wrap: "",
  finance_initial: "",
  homeowner_signature: "",
  homeowner_sign_date: "",
  rep_signature: "",
  rep_sign_date: "",
  contract_date: "",
  cancel_customer_name: "",
  cancel_phone: "",
  cancel_address: "",
  cancel_signed_date: "",
  cancel_signature: "",
  color_choice: "",
  color_other: "",
  color_initial: "",
  cert_claim_number: "",
  cert_address: "",
  cert_city: "",
  cert_state: "",
  cert_zip: "",
  cert_damage_type: "",
  cert_loss_date: "",
  cert_homeowner_signature: "",
});
